export default __webpack_public_path__ + "7ba5f67f5ad7a58b67a8dd5d16a330d8.png";